import { ChainId } from '@sushiswap/sdk'
import { createAction } from '@reduxjs/toolkit'

export interface SerializableTransactionReceipt {
    to: string
    from: string
    contractAddress: string
    transactionIndex: number
    blockHash: string
    transactionHash: string
    blockNumber: number
    status?: number
}

export const addTransaction = createAction<{
    chainId: ChainId
    hash: string
    from: string
    approval?: { tokenAddress: string; spender: string }
    claim?: { recipient: string }
    summary?: string
    archer?: {
        rawTransaction: string
        deadline: number
        nonce: number
        ethTip: string
    }
}>('transactions/addTransaction');
export const clearAllTransactions = createAction<{ chainId: ChainId }>('transactions/clearAllTransactions');
export const finalizeTransaction = createAction<{
    chainId: ChainId
    hash: string
    receipt: SerializableTransactionReceipt
}>('transactions/finalizeTransaction');
export const checkedTransaction = createAction<{
    chainId: ChainId
    hash: string
    blockNumber: number
}>('transactions/checkedTransaction');

export const transactionTab = createAction<{removeSideTab : boolean}>('transactions/transactionTab');

export const detailsTab = createAction<{removeDetailsTab : boolean}>('transactions/detailsTab');
export const refreshTransactionTab = createAction<{refresh : number}>('transactions/refreshTab');
export const notificationTab = createAction<{setPriceNotification? : number,autoTimeNotification? : number,address?: string}>('transactions/notificationTab');
